<template>
    <div class="py-12">
        <DataTable
            class="mt-10"
            :headers="headers"
            :items="logs"
            searchable
            :title="$t('vue.testing_logs')"
        >
            <template #item-created_at="{ data }">
                <div class="flex p-6">
                    <div v-if="data">
                        {{
                            format(
                                new Date(data as string),
                                "d. L. yyyy HH:mm:ss",
                            )
                        }}
                    </div>
                </div>
            </template>

            <template #item-actions="{ row }">
                <div class="flex justify-end p-6">
                    <AtomicButton
                        size="sm"
                        color="yellow"
                        @click="openLog(row as ITestingLog)"
                    >
                        <template #icon>
                            <CodeBracketSquareIcon class="h-6 w-6" />
                        </template>
                    </AtomicButton>
                    <AtomicButton
                        class="ml-2"
                        size="sm"
                        color="red"
                        @click="deleteLog(row as ITestingLog)"
                    >
                        <template #icon>
                            <TrashIcon class="h-6 w-6" />
                        </template>
                    </AtomicButton>
                </div>
            </template>
        </DataTable>
    </div>
</template>

<script lang="ts" setup>
import { format } from "date-fns";
import route from "ziggy-js";

import { TrashIcon, CodeBracketSquareIcon } from "@heroicons/vue/24/outline";
import type IPaginationData from "@/components/Atomic/DataTable/types/IPaginationData";
import type IDataTableHeader from "@/components/Atomic/DataTable/types/IDataTableHeader";
import { router } from "@inertiajs/vue3";
import { create } from "@/composables/useNotifications";
import useConfirm from "@/composables/useConfirm";

defineProps<{
    logs: IPaginationData<any>;
}>();

const { show } = useConfirm();

const headers: IDataTableHeader[] = [
    { text: $t("vue.id"), id: "id", sortable: true, sortableId: "id" },
    { text: $t("vue.name"), id: "name", sortable: true, sortableId: "name" },
    {
        text: $t("vue.created"),
        id: "created_at",
        sortable: true,
        sortableId: "created_at",
    },
    { text: "", id: "actions" },
];

const openLog = async (log: any) => {
    window.open(route("kiosk.testing-logs.show", log.id), "_blank");
};

const deleteLog = async (log: any) => {
    const confirmed = await show({
        header: $t("vue.delete_log_header"),
        message: $t("vue.delete_log_message"),
        type: "danger",
        confirm: $t("vue.delete"),
    });

    if (confirmed) {
        router.delete(
            route("kiosk.testing-logs.destroy", {
                log: log.id,
            }),
            {
                preserveScroll: true,
                onSuccess: () => {
                    create({
                        title: $t("vue.log_deleted"),
                        type: "success",
                    });
                },
                onError: () => {
                    create({
                        title: $t("vue.log_not_deleted"),
                        type: "error",
                    });
                },
            },
        );
    }
};
</script>
